import React from 'react';
import {
  Avatar,
  createTheme,
  Box,
  Card,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Button
} from '@mui/material';
import Client from '../Client';
import { ordersDetail } from './simpleBiReportsApi';
import SearchIcon from '@mui/icons-material/Search';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import OrderDateInfo from './components/OrderDateInfo';

let theme = createTheme();

const objectToCsv = function (data) {
  const csvRows = [];

  if (!data || !data.length) {
    return "No data";
  }

  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header];
      return `"${String(val).replace(/"/g, '""')}"`;
    });

    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

class SalesOrderView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      saleslocation_list: {},
      irefOrder: "",
      page: 0,
      rowsPerPage: 8,
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.setOrder = this.setOrder.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    const irefOrder = this.state.irefOrder;

    if (!irefOrder) {
      this.setState({
        saleslocation_list: {},
        filterData: {},
        page: 0
      });

      return;
    }

    const queryData = {
      iref: irefOrder
    };

    const data = ordersDetail(this.state.client, queryData);

    if (!data || !data.result) {
      console.error("Order view API unavailable", {
        endpoint: "ordersDetail",
        payload: queryData,
        response: data
      });

      this.setState({
        saleslocation_list: {},
        filterData: queryData,
        page: 0
      });

      return;
    }

    this.setState({
      saleslocation_list: data,
      filterData: queryData,
      page: 0
    });
  }

  doSync() {
    this.getData();
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: +event.target.value,
      page: 0
    });
  }

  setOrder = (event) => {
    const iref = event.target.value;

    if (iref === "") {
      this.setState({ irefOrder: "" });
      return;
    }

    if (!/^\d+$/.test(iref)) {
      return;
    }

    this.setState({
      irefOrder: iref
    });
  }

  onDownload = () => {
    const result = this.state.saleslocation_list?.result;
    const orderLines = result?.orderlines || [];

    if (!result || !Array.isArray(orderLines) || orderLines.length === 0) {
      return;
    }

    const link = document.createElement("a");
    link.download = "orderView_" + this.state.irefOrder + ".csv";

    const csvData = objectToCsv(orderLines);

    const csvHeader =
      "Order: " + (this.state.irefOrder || "") +
      "\nLocation: " + (result.location || "") +
      "\nDate: " + (result.date || "") +
      "\nValue: " + (result.valueWVat || "") +
      "\nValueNoVAT: " + (result.valueWoVat || "") +
      "\n";

    const csv = "\uFEFF" + csvHeader + "\n" + csvData;

    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    link.click();
  };

  render() {
    const page = this.state.page;
    const rowsPerPage = this.state.rowsPerPage;

    let productSalesList = [];
    let fOrder = {};

    if (this.state.saleslocation_list?.result) {
      fOrder = this.state.saleslocation_list.result;

      if (Array.isArray(fOrder.orderlines)) {
        Object.keys(fOrder.orderlines).forEach(key => {
          let fData = fOrder.orderlines[key];

          if (fData.index > 0) {
            let quantity = parseFloat(fData.quantity || 0);
            let vat = parseFloat(fData.vat || 0);
            let productValue = parseFloat(fData.productValue || 0);

            let p = {
              id: fData.index,
              product: fData.productName,
              quantity: fData.quantity,
              price: quantity ? parseFloat(productValue + vat / quantity).toFixed(2) : "0.00",
              value: parseFloat(fData.value || 0).toFixed(2),
              valueNoVAT: parseFloat(fData.valueNoVAT || 0).toFixed(2)
            };

            productSalesList.push(p);
          }
        });
      }
    }

    const pagedProductSalesList = productSalesList.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

    return (
      <Card
        sx={{
          borderRadius: "14px",
          overflow: "hidden",
          height: {
            xs: "calc(100vh - 92px)",
            md: "calc(100vh - 104px)"
          },
          minHeight: {
            xs: 500,
            sm: 540
          },
          display: "flex",
          flexDirection: "column"
        }}
      >
        {/* Search / actions */}
        <Box
          sx={{
            px: {
              xs: 1,
              sm: 1.5
            },
            py: {
              xs: 0.75,
              sm: 1
            },
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr 40px",
              sm: "180px 40px auto",
              md: "200px 40px auto 40px"
            },
            gap: {
              xs: 1,
              sm: 1.25
            },
            alignItems: "end",
            borderBottom: "1px solid rgba(0,0,0,0.08)"
          }}
        >
          <TextField
            label="OrderNo"
            variant="standard"
            id="OrderNo"
            value={this.state.irefOrder}
            sx={this.filterSx()}
            inputProps={{
              min: 0,
              inputMode: "numeric",
              pattern: "[0-9]*",
              style: { textAlign: 'center' }
            }}
            onChange={this.setOrder}
            required={true}
          />

          <Button
            color="inherit"
            size="small"
            onClick={this.getData}
            variant="contained"
            sx={{
              maxWidth: '38px',
              minWidth: '38px',
              maxHeight: '38px',
              minHeight: '38px'
            }}
          >
            <Avatar sx={{ width: 25, height: 25 }}>
              <SearchIcon fontSize="small" />
            </Avatar>
          </Button>

          <Box sx={{ display: { xs: "none", sm: "block" } }} />

          <Button
            color="inherit"
            size="small"
            onClick={this.onDownload}
            variant="contained"
            sx={{
              maxWidth: '38px',
              minWidth: '38px',
              maxHeight: '38px',
              minHeight: '38px',
              display: {
                xs: 'none',
                sm: 'none',
                md: 'inline-flex'
              },
              justifySelf: "end"
            }}
          >
            <Avatar sx={{ width: 25, height: 25, bgcolor: theme.palette.success.light }}>
              <FileDownloadIcon fontSize="small" />
            </Avatar>
          </Button>
        </Box>

        {/* Order summary */}
        <Box
          sx={{
            px: {
              xs: 1,
              sm: 1.5
            },
            py: {
              xs: 0.75,
              sm: 1
            },
            borderBottom: "1px solid rgba(0,0,0,0.08)"
          }}
        >
          <TableContainer
            sx={{
              maxHeight: {
                xs: 118,
                sm: 125
              },
              overflow: "auto",
              borderRadius: "12px",
              border: "1px solid rgba(0,0,0,0.08)"
            }}
          >
            <Table stickyHeader aria-label="order summary table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={this.headerCellSx("center")}>
                    <b>Order</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("left")}>
                    <b>Location</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("left", 125)}>
                    <b>Created</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("left")}>
                    <b>Delivery</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("right")}>
                    <b>Value</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("right")}>
                    <b>No VAT</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("center")}>
                    <b>Lines</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow>
                  <TableCell sx={this.bodyCellSx("center", false)}>
                    {fOrder.order || ""}
                  </TableCell>

                  <TableCell sx={this.bodyCellSx("left")}>
                    {fOrder.location || ""}
                  </TableCell>

                  <TableCell sx={this.bodyCellSx("left", false, 125)}>
                    <OrderDateInfo createdOn={fOrder.createdOn} deliveredOn={fOrder.deliveredOn}>
                      {fOrder.date || ""}
                    </OrderDateInfo>
                  </TableCell>

                  <TableCell sx={this.bodyCellSx("left")}>
                    {fOrder.delivery || ""}
                  </TableCell>

                  <TableCell sx={this.bodyCellSx("right", false)}>
                    {fOrder.valueWVat ? parseFloat(fOrder.valueWVat).toFixed(2) : "0.00"}
                  </TableCell>

                  <TableCell sx={this.bodyCellSx("right")}>
                    {fOrder.valueWoVat ? parseFloat(fOrder.valueWoVat).toFixed(2) : "0.00"}
                  </TableCell>

                  <TableCell sx={this.bodyCellSx("center")}>
                    {fOrder.lines || ""}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Order lines */}
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            px: {
              xs: 1,
              sm: 1.5
            }
          }}
        >
          <TableContainer
            sx={{
              height: "100%",
              overflow: "auto",
              borderRadius: "12px",
              border: "1px solid rgba(0,0,0,0.08)"
            }}
          >
            <Table stickyHeader aria-label="order lines table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={this.headerCellSx("center")}>
                    <b>Index</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("left")}>
                    <b>Product</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("center")}>
                    <b>Qty</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("right")}>
                    <b>Price</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("right")}>
                    <b>Value</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("right")}>
                    <b>No VAT</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {pagedProductSalesList.map((product) => {
                  return (
                    <TableRow
                      hover
                      key={product.id}
                      tabIndex={-1}
                    >
                      <TableCell sx={this.bodyCellSx("center")}>
                        {product.id}
                      </TableCell>

                      <TableCell sx={this.bodyCellSx("left", false)}>
                        {product.product}
                      </TableCell>

                      <TableCell sx={this.bodyCellSx("center")}>
                        {product.quantity}
                      </TableCell>

                      <TableCell sx={this.bodyCellSx("right")}>
                        {product.price}
                      </TableCell>

                      <TableCell sx={this.bodyCellSx("right", false)}>
                        {product.value}
                      </TableCell>

                      <TableCell sx={this.bodyCellSx("right")}>
                        {product.valueNoVAT}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[8, { value: productSalesList.length, label: 'All' }]}
          labelRowsPerPage="Rows:"
          component="div"
          count={productSalesList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          sx={{
            borderTop: "1px solid rgba(0,0,0,0.08)",
            ".MuiTablePagination-toolbar": {
              minHeight: {
                xs: 46,
                sm: 52
              },
              px: {
                xs: 1,
                sm: 2
              }
            },
            ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
              fontSize: {
                xs: "13px",
                sm: "13px"
              }
            },
            ".MuiTablePagination-actions button": {
              padding: {
                xs: "4px",
                sm: "8px"
              }
            }
          }}
        />
      </Card>
    );
  }

  filterSx() {
    return {
      width: "100%",
      minWidth: 0,
      "& .MuiInputBase-input": {
        fontSize: {
          xs: "14px",
          sm: "14px"
        }
      },
      "& .MuiInputLabel-root": {
        fontSize: {
          xs: "13px",
          sm: "13px"
        }
      }
    };
  }

  headerCellSx(align, minWidth = null) {
    return {
      padding: {
        xs: "8px 7px",
        sm: "7px"
      },
      textAlign: align,
      whiteSpace: "nowrap",
      minWidth: minWidth,
      fontSize: {
        xs: "13px",
        sm: "13px",
        md: "14px"
      },
      backgroundColor: "#f6f4ef"
    };
  }

  bodyCellSx(align, strong = false, minWidth = null) {
    return {
      padding: {
        xs: "8px 7px",
        sm: "7px"
      },
      textAlign: align,
      whiteSpace: align === "left" ? "normal" : "nowrap",
      minWidth: minWidth,
      fontSize: {
        xs: "13.5px",
        sm: "13px",
        md: "14px"
      },
      fontWeight: strong ? 600 : 400,
      lineHeight: 1.35
    };
  }
}

export default SalesOrderView;
